import styled from "styled-components";

export const StyledActionButtonBarContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
`;
